import { TrackedJob } from "~frontend/__generated__/graphql";

import { CampaignForEditor } from "../types";

export function getRunningOverlapJobForCampaign(
  campaign: CampaignForEditor | null | undefined
): Pick<
  TrackedJob,
  "id" | "type" | "progress" | "status" | "errorMessage"
> | null {
  if (!campaign) {
    return null;
  }

  return (
    campaign.createSuppressionsFromCampaignOverlapsJob ||
    campaign.createSuppressionsFromListJob ||
    campaign.deleteSuppressionsJob ||
    null
  );
}
